<template>
  <div 
    v-if="list.length"
    class="sm-customers-table"
    :class="{
      'lvl3': provider.client_level == 3
    }"
  >
    <customers-table-lvl3
      v-if="provider.client_level == 3"
      :list="list"
      @action="handleAction"
    />
    <customers-table-lvl1
      v-else-if="provider.client_level == 1"
      :list="list"
      @action="handleAction"
    />
    <customers-table
      v-else
      :list="list"
      @action="handleAction"
    />

    <popup-block
      v-if="popup.isOpen"
      :open="popup.isOpen"
      :size="popup.type == 'activate' || 'deactivate' ? 'large' : 'default'"
      @close="popup.isOpen = false;"
    >
      <template slot="popupContent">
        <div
          v-if="popup.type == 'pmb'" 
          class="sm-customers-table__popup"
        >
          <h4>Mailbox Number</h4>
          <p>Choose available or enter Mailbox# for {{popup.item.full_name}}</p>
          <dropdown-wrap
            v-model="selectedPMB"
            :class="{
              'error': errors.first('selected_pmb')
            }"
            :options="availablePMBs"
            :placeholder="'Select or enter Mailbox#'"
            :params="{
              searchable: true,
              taggable: true,
              tagItemTpl: {
                name: 'Mailbox #',
                number: ''
              }
            }"
            @tag="handleTag"
          />
          <btn-block
            :text="'Assign Mailbox#'"
            @click="sendSelectedPMB"
          />
        </div>
        <div
          v-if="popup.type == 'pass'" 
          class="sm-customers-table__popup"
        >
          <h4>Re-enter your admin password</h4>
          <input-text
            v-model="password"
            :value="password"
            :label="'Password'"
            :name="'password'"
            :type="'password'"
            v-validate="`required|min:6`"
            :error="errors.first('password')"
          />
          <btn-block
            :text="'Log in'"
            @click="loginAsCustomer"
          />
        </div>
        <div
          v-if="popup.type == 'error'" 
          class="sm-customers-table__popup"
        >
          <h4 class="sm-txt-center">Error!</h4>
          <p class="sm-txt-center sm-red">{{popup.item}}</p>
          <btn-block
            :type="'small'"
            :text="'Ok'"
            @click="popup.isOpen = false"
          />
        </div>
        <activate-customer
          v-if="popup.type == 'activate'" 
          :item="popup.item"
          :coupons="coupons"
          :plans="plans"
          @cancel="popup.isOpen = false"
          @activate="activateCustomer"
          @cancelScheduled="cancelScheduled"
        />
        <deactivate-customer
          v-if="popup.type == 'deactivate'" 
          :popup="popup"
          :curDeactivationOption="curDeactivationOption"
          @deactivate="deactivateCustomer"
        />
        <!-- <form
           v-if="popup.type == 'deactivate'" 
          class="sm-list__popup-form"
          @submit.prevent="() => false"
        >
          <h4>Deactivate {{popup.item.full_name}}</h4>
          <div class="sm-list__popup-form-radio deactivate">
            <radiobutton-block
              v-for="(item, index) in popup.options"
              :key="index"
              v-model="curDeactivationOption"
              :text="item.title"
              :description="index === 1 ? $moment(item.value).format('MMM DD, YYYY') : ''"
              :name="'deactiavte'"
              :checked="curDeactivationOption.title === popup.options[index].title"
              @input="curDeactivationOption = item; popup.options[2].value = ''"
            >
              <div v-if="index === 2 && curDeactivationOption.title === popup.options[index].title" class="radio-datepicker">
                <datepicker-wrap
                  v-model="popup.options[2].value"
                  :notBefore="new Date()"
                />
              </div>
            </radiobutton-block>
          </div>
          <btn-block
            :type="'warning'"
            @click="deactivateCustomer({id: popup.item.id, expires_on: curDeactivationOption.value})"
            :classes="[{disabled: curDeactivationOption.value === ''}]"
            :text="`Deactivate Customer`"
          />
        </form> -->
        <confirm-block
          v-if="popup.type == 'delete'" 
          :title="'Delete this customer?'"
          :confirmType="'error'"
          :confirmText="'Delete'"
          @confirm="delCustomer({id: popup.item.id})"
          @cancel="popup.isOpen = false"
        >
          <slot name="content">
            <p>
               <span class="sm-txt-strong">{{popup.item.full_name}}</span>'s account will be deleted and their information will not be restored.
            </p></slot>
        </confirm-block >
        <unsubscribe-customer
          v-if="popup.type == 'unsubscribe'"
          :item="popup.item"
          @cancel="popup.isOpen = false"
          @unsubscribe="deactivateCustomer"
        />
        <div 
          v-if="popup.type == 'recipients'"
          class="sm-customers-table__popup"
        >
          <h4>Additional recipients:</h4>
          <ul>
            <li
              v-for="recip in popup.item.joint_accounts"
              :key="recip.id"
            >{{recip.first_name}} {{recip.last_name}}</li>
          </ul>
          <btn-block
            :text="'Close'"
            @click="popup.isOpen = false"
          />
        </div>
        <quick-mail
          v-if="popup.type == 'quick-mail'"
          :pmb="popup.item"
          @add="addQuickMail"
        />
        <run-billing
          v-if="popup.type == 'billing'"
          :item="popup.item"
          @run="runBilling"
          @cancel="popup.isOpen = false"
        />
      </template>
    </popup-block>

    <sm-spinner :show="showSpinner" />
  </div>
  <empty-customers-table
    v-else
    @new="$emit('new')"
  />
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import Spinner from '@/components/Spinner';
import Popup from '@/components/Popup';
import DropdownWrap from '@/components/DropdownWrap';
import InputText from '@/components/InputText';
import Confirm from '@/components/Confirm';
import ActivateCustomer from '@/components/customers/ActivateCustomer';
import DeactivateCustomer from '@/components/customers/DeactivateCustomer';
import UnsubscribeCustomer from '@/components/customers/UnsubscribeCustomer';
import QuickMail from '@/components/customers/QuickMail';
import RunBilling from '@/components/customers/RunBilling';
import Periods from '@/settings/periods';
import {FormatPrice} from '@/utils/general-data';
import EmptyTable from '@/views/admin/pages/customers/components/EmptyTable';
import CustomersTable from '@/views/admin/pages/customers/components/Table';
import CustomersTableLvl3 from '@/views/admin/pages/customers/components/TableLvl3';
import CustomersTableLvl1 from '@/views/admin/pages/customers/components/TableLvl1';
import {ParseErrorText} from '@/utils/errors';
import Radiobutton from '@/components/Radiobutton';
import DatepickerWrap from '@/components/DatepickerWrap';
export default {
  name: 'customers-controller',
  components: {
    'sm-spinner': Spinner,
    'popup-block': Popup,
    'dropdown-wrap': DropdownWrap,
    'input-text': InputText,
    'confirm-block': Confirm,
    'activate-customer': ActivateCustomer,
    'deactivate-customer': DeactivateCustomer,
    'unsubscribe-customer': UnsubscribeCustomer,
    'quick-mail': QuickMail,
    'run-billing': RunBilling,
    'empty-customers-table': EmptyTable,
    'customers-table': CustomersTable,
    'customers-table-lvl3': CustomersTableLvl3,
    'customers-table-lvl1': CustomersTableLvl1,
    'radiobutton-block': Radiobutton,
    'datepicker-wrap': DatepickerWrap
  },
  props: {
    list: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      showSpinner: false,
      popup: {
        type: '', // values: pmb, pass, error, activate, deactivate, recipients, unsubscribe
        isOpen: false,
        item: '',
        options: [
          {
            title: 'Cancel now',
            value: undefined
          },
          {
            title: 'Cancel at the subscription end date',
            value: ''
          },
          {
            title: 'Manually set a date for cancellation',
            value: ''
          }
        ]
      },
      curDeactivationOption: {
        title: 'Cancel now',
        value: undefined
      },
      selectedPMB: null,
      availablePMBs: [],
      password: '',
      plans: [],
      coupons: [],
      periodAlts: Periods.alts,
      notifKey: 0,
    };
  },
  computed: {
    ...mapGetters({
      isMobile: 'isMobile',
      access: 'auth/access',
      user: 'auth/user',
      provider: 'provider'
    }),
  },
  created() {
    Promise.all([
      this.getPlans(true),
      this.getCoupons()
    ])
      .then(([plans, coupons]) => {
        this.plans = [];

        plans.forEach(plan => {
          this.plans.push({
            id: plan.id,
            name: `${plan.title} - ${this.formatPrice(plan.period_amount)}/${this.periodAlts[plan.period_unit]}${!plan.is_active ? ' (Hidden)' : ''}`,
            setup_fee: plan.setup_fee,
            term: plan.period_unit
          });

          this.plans.push({
            id: plan.id,
            name: `${plan.title} - ${this.formatPrice(plan.subscription_price)}/month${!plan.is_active ? ' (Hidden)' : ''}`,
            setup_fee: plan.setup_fee,
            term: 'monthly'
          });
        });

        this.coupons = coupons;
      })
      .catch(e => {
        console.log(e, e.response);
      });
  },
  methods: {
    ...mapActions({
      getAvailablePMBs: 'mail/getAvailablePMBs',
      updateCustomerPMB: 'customers/updateCustomerPMB',
      authCustomer: 'customers/authCustomer',
      confirmLogin: 'auth/confirmLogin',
      enableCustomer: 'customers/enableCustomer',
      cancelScheduledActivation: 'customers/cancelScheduledActivation',
      disableCustomer: 'customers/disableCustomer',
      deleteCustomer: 'customers/deleteCustomer',
      getPlans: 'plans/getPlans',
      getCoupons: 'billing/getCoupons',
      getRecipients: 'wrappers/getCustomerRecipients',//'account/getRecipients',
      createNewMail: 'mail/createNewMail',
      runTestBilling: 'billing/runTestBilling'
    }),
    formatPrice: FormatPrice,
    handleAction(data) {
      switch(data.name) {
        case 'pmb':
          this.showUpdatePMB(data.id);
          break;
        case 'login':
          this.loginNoConfirm(data.id);
          break;
        case 'activate':
          this.handleActivate(data.id);
          break;
        case 'deactivate':
          this.handleDeactivate(data.id);
          break;
        case 'delete':
          this.handleDelete(data.id);
          break;
        case 'unsubscribe':
          this.handleUnsubscribe(data.id);
          break;
        case 'recipients':
          this.showRecipients(data.customer);
          break;
        case 'sort':
          this.$emit('sort', data.params);
          break;
        case 'quick-mail':
          this.popup.type = 'quick-mail';
          this.popup.item = data.pmb;
          this.popup.isOpen = true;
          break;
        case 'billing':
          this.popup.type = 'billing';
          this.popup.item = data.customer;
          this.popup.isOpen = true;
          break;
        default:
          break;
      }
    },
    showUpdatePMB(customerId) {
      this.showSpinner = true;
      this.getAvailablePMBs()
        .then(res => {
          this.availablePMBs = res.account_numbers.map(item => {
            return {
              number: item,
              name: `Mailbox #${item}`
            };
          });

          this.popup.type = 'pmb';
          this.popup.item = this.list.find(item => item.id == customerId);
          this.popup.isOpen = true;

          this.showSpinner = false;
        });
    },
    sendSelectedPMB() {
      if (!this.selectedPMB) {
        this.errors.add({
          field: 'selected_pmb',
          msg: 'Please select Mailbox#'
        });
        return;
      }
      
      this.showSpinner = true;
      this.updateCustomerPMB({
        id: this.popup.item.id,
        params: {
          account_number: this.selectedPMB.number
        }
      })
        .then(res => {
          this.$emit('update-list');
          this.popup.isOpen = false;

          this.showSpinner = false;
        })
        .catch(e => {
          let err = e.response;
          
          if (err && err.data && err.data.errors && err.data.errors.length) {
            this.popup.type = 'error';
            this.popup.item = err.data.errors[0];
          } else {
            this.popup.isOpen = false;
          }

          this.showSpinner = false;
        })
    },
    confirmPassword(id) {
      this.password = '';
      this.popup.type = 'pass';
      this.popup.item = id;
      this.popup.isOpen = true;
    },
    loginAsCustomer() {
      if (this.errors.first('password'))
        return;

      this.showSpinner = true;
      let id = this.popup.item;

      this.confirmLogin({ 
        login: this.user.user_name, 
        password: this.password
      })
        .then(() => {
          this.authCustomer(id)
            .then(res => {
              if (!res) {
                this.showSpinner = false;
                return;
              }

              localStorage.setItem('admin-access', btoa(JSON.stringify(this.access)));

              this.$router.push(`/customer?refresh_token=${res.refresh_token}&access_token=${res.access_token}&is_admin=true`);
            })
            .catch(err => {
              this.popup.isOpen = false;
              this.showSpinner = false;
            })
        })
        .catch(err => {
          this.errors.add({
            field: 'password',
            msg: 'Invalid password'
          });
          this.showSpinner = false;
        });
    },
    // TEMP - replace after able to login admin in new app
    loginNoConfirm(id) {
      this.showSpinner = true;
      this.authCustomer(id)
        .then(res => {
          if (!res) {
            this.showSpinner = false;
            return;
          }

          localStorage.setItem('admin-access', btoa(JSON.stringify(this.access)));

          this.$router.push(`/customer?refresh_token=${res.refresh_token}&access_token=${res.access_token}&is_admin=true`);
        })
        .catch(err => {
          this.showSpinner = false;
        });
    },
    handleActivate(id) {
      this.popup.type = 'activate';
      this.popup.item = this.popup.item = this.list.find(item => item.id == id);
      this.popup.isOpen = true;
    },
    handleDeactivate(id) {
      this.popup.type = 'deactivate';
      this.popup.item = this.popup.item = this.list.find(item => item.id == id);
      this.popup.isOpen = true;
    },
    handleDelete(id) {
      this.popup.type = 'delete';
      this.popup.item = this.popup.item = this.list.find(item => item.id == id);
      this.popup.isOpen = true;
    },
    handleUnsubscribe(id) {
      this.popup.type = 'unsubscribe';
      this.popup.item = this.popup.item = this.list.find(item => item.id == id);
      this.popup.isOpen = true;
    },
    activateCustomer(data) {
      this.showSpinner = true;
      this.enableCustomer(data)
        .then(res => {
          this.$emit('update-list');
          this.popup.isOpen = false;
          this.showSpinner = false;
        })
        .catch(e => {
          console.log(e, e.response);
          if (e.response) {
            let err = e.response;
            if (err.status == 422 && err.data && err.data.errors && Object.keys(err.data.errors).length) {
              this.popup.type = 'error';
              this.popup.item = ParseErrorText(err.data.errors);
              this.popup.isOpen = true;
            }
          }
          this.showSpinner = false;
        });
    },
    cancelScheduled(data) {
      this.showSpinner = true;
      this.cancelScheduledActivation(data)
        .then(res => {
          this.$emit('update-list');
          this.popup.isOpen = false;
          this.showSpinner = false;
        })
        .catch(e => {
          console.log(e, e.response);
          if (e.response) {
            let err = e.response;
            if (err.status == 422 && err.data && err.data.errors && Object.keys(err.data.errors).length) {
              this.popup.type = 'error';
              this.popup.item = ParseErrorText(err.data.errors);
              this.popup.isOpen = true;
            }
          }
          this.showSpinner = false;
        });
    },
    deactivateCustomer(data) {
      this.showSpinner = true;
      
      this.disableCustomer(data)
        .then(res => {
          this.$emit('update-list');
          this.popup.isOpen = false;
          this.showSpinner = false;
        })
        .catch(e => {
          console.log(e, e.response);
          if (e.response) {
            let err = e.response;

            if (err.status == 422 && err.data && err.data.errors && err.data.errors.base) {
              this.popup.type = 'error';
              this.popup.item = err.data.errors.base[0];
              this.popup.isOpen = true;
            }
          }
          
          this.showSpinner = false;
        });
    },
    delCustomer(data) {
       this.showSpinner = true;
      
      this.deleteCustomer(data)
        .then(res => {
          this.$emit('update-list');
          this.popup.isOpen = false;
          this.showSpinner = false;
        })
        .catch(e => {
          console.log(e, e.response);
          if (e.response) {
            let err = e.response;

            if (err.status == 422 && err.data && err.data.errors && err.data.errors.base) {
              this.popup.type = 'error';
              this.popup.item = err.data.errors.base[0];
              this.popup.isOpen = true;
            }
          }
          
          this.showSpinner = false;
        });

    },
    handleTag(val) {
      this.selectedPMB = {
        name: `Mailbox #${val}`,
        number: Number(val)
      };
    },
    showRecipients(customer) {
      if (customer.joint_accounts)
        return;

      this.getRecipients(customer.id)
        .then(res => {
          customer.joint_accounts = res.joint_accounts;
        });
    },
    addQuickMail(data) {
      let toSend = {
        mail_item: {
          received_at: this.$moment(new Date()).format('YYYY-MM-DD'),
          account_numbers: [data.pmb],
          sender: 'Incoming mail',
          quantity: data.quantity,
          mail_type_id: 1,
          is_scannable: true,
          weight_unit: 'lb',
          weight: 0,
          // tracking: '',
          // comments: ''
        }
      };

      this.showSpinner = true;
      this.createNewMail(toSend)
        .then(res => {
          this.notifKey++;
          this.$emit('notif', {
            id: `notif-${this.notifKey}`,
            text: 'Mail has been successfuly added'
          })
          this.popup.isOpen = false;
          this.showSpinner = false;
        })
    },
    runBilling(data) {
      this.showSpinner = true;

      this.runTestBilling(data)
        .then(res => {
          this.popup.isOpen = false;
          this.showSpinner = false;
        })
    }
  },
  watch: {
    'popup.item'(val) {
      this.popup.options[1].value = val.next_billing_date;
    },
    'popup.isOpen'(val) {
      if (!val) {
        this.errors.clear();
      }
    }
  }
}
</script>

<style lang="scss">
  @use '@/assets/scss/general/mixins.scss' as *;
  @use '@/assets/scss/framework/scss-variables.scss' as *;
  @use '@/assets/scss/pages/common/customers/_customers-table.scss';
  @use '@/assets/scss/pages/common/mail/_list.scss';

</style>